<template>
  <div class="invite-list">
    <div class="invite-list-section" v-if="list.length > 0">
      <van-row
        class="invite-list-section-box"
        v-for="item in list"
        :key="item.id"
      >
        <img
          class="invite-list-section-box-tbg"
          width="100%"
          src="/static/bytx/ylfw/medical_appointment_title@3x.png"
          alt=""
        />
        <div class="invite-list-title">{{ item.title }}</div>
        <van-image
          fit="cover"
          class="invite-list-content-img"
          :src="item.img"
          width="60"
          height="60"
        />
        <div class="clear"></div>
        <div class="invite-list-content-box">
          <div :class="'invite-list-content-desc ' + item.more">
            {{ item.intro }}
          </div>
          <div class="invite-list-content-desc-line"></div>
          <div v-if="!item.more" class="pull-more" @click="showMore(item)">
            展开全部简介
            <img src="/static/bytx/ylfw/invite-list-down.svg" alt="" />
          </div>

          <div v-else class="pull-more" @click="showMore(item)">
            收起全部简介
            <img src="/static/bytx/ylfw/invite-list-top.svg" alt="" />
          </div>

          <div
            class="invite-list-btn"
            @click="goInvite(item)"
            style="text-align: center;color: #fff;line-height: 36px;"
          >
            预约挂号
          </div>
          <div class="clear"></div>
        </div>
      </van-row>
    </div>
  </div>
</template>
<script>
import Interface from "@/util/interface";
import inviteListSkeleton from "@/skeleton/articleListSkeleton";
import { LocationHref } from "@/util/common";

export default {
  name: "invite-list",
  components: {
    "invite-list-skeleton": inviteListSkeleton
  },
  data() {
    return {
      list: []
    };
  },
  methods: {
    showMore(item) {
      item.more = !item.more;
    },
    goInvite(item) {
      Interface.mFootPrint(item.id, 74, 0, 4, 0, "", 0, item.title);
      if (item.title == "春富研究院") {
        this.$router.push("/invite-detail?title=" + item.title);
      } else {
        LocationHref(item.content);
      }
    },
    fetch(scene) {
      if (scene === "list") {
        Interface.getData("get", Interface.medical.invite, {
          pageSize: 100
        }).then(res => {
          res.data.list.forEach(val => {
            val.more = false;
          });
          this.list = res.data.list;

          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
      }
    }
  },
  created() {
    this.fetch("list");
    sessionStorage.removeItem("search_data");
    // Interface.footPrint(23, 1, 0, "浏览博医同行预约挂号")
    // let obj = [{ origin_id: 0, type: 74, title: '预约门诊列表页', page_type: 4}]
    // Interface.exposureFootPrint(JSON.stringify(obj))
    Interface.mFootPrint(1, 104, 0, 4, 0, 0, 0, "预约门诊列表页");
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/invite/list/index.vue